export const AchievementBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      <div
        className="absolute inset-0
          [--mat-vignette:hsl(34_30%_44%_/_0.13)]
          dark:[--mat-vignette:rgba(0,0,0,0.4)]
          [--spot-warmth:hsl(40_58%_55%_/_0.16)]
          dark:[--spot-warmth:hsl(38_38%_65%_/_0.09)]
          [--mat-bloom:hsl(36_42%_50%_/_0.10)]
          dark:[--mat-bloom:hsl(38_28%_55%_/_0.04)]"
      >
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 60% 45% at 50% 8%, var(--spot-warmth), transparent 70%)',
          }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              'radial-gradient(ellipse 55% 45% at 50% 55%, var(--mat-bloom), transparent 75%)',
          }}
        />
        <div
          className="absolute inset-12"
          style={{
            background:
              'radial-gradient(ellipse 80% 70% at 50% 50%, transparent 55%, var(--mat-vignette))',
          }}
        />

        <div className="absolute inset-8 border border-primary/45 rounded-sm" />
        <div className="absolute inset-[44px] border border-primary/15 rounded-sm" />

        <CornerDiamond className="top-8 left-8 -translate-x-1/2 -translate-y-1/2" />
        <CornerDiamond className="top-8 right-8 translate-x-1/2 -translate-y-1/2" />
        <CornerDiamond className="bottom-8 left-8 -translate-x-1/2 translate-y-1/2" />
        <CornerDiamond className="bottom-8 right-8 translate-x-1/2 translate-y-1/2" />
      </div>
    </div>
  )
}

const CornerDiamond = ({ className }: { className: string }) => (
  <div className={`absolute ${className} w-5 h-5`}>
    <svg viewBox="0 0 20 20" fill="none" className="w-full h-full">
      <path d="M 10 3 L 17 10 L 10 17 L 3 10 Z" fill="hsl(var(--color-background))" />
      <path d="M 10 3 L 17 10 L 10 17 L 3 10 Z" fill="hsl(var(--color-primary) / 0.55)" />
      <path
        d="M 10 3 L 17 10 L 10 17 L 3 10 Z"
        stroke="hsl(var(--color-primary))"
        strokeOpacity="0.8"
        strokeWidth="0.75"
      />
      <circle cx="10" cy="10" r="1.4" fill="hsl(var(--color-primary))" fillOpacity="0.9" />
    </svg>
  </div>
)
